<footer class="cj-footer" role="contentinfo" aria-label="Informații și linkuri">
  <!-- Rândul 1: 4 coloane -->
  <div class="top">
    <div class="col proiect">
      <img src="assets/img/eu-gov.webp" alt="EU-GOV" width="216" height="47" loading="lazy" />
        <p>
            <strong>Programul Incluziune și Demnitate Socială 2021-2027</strong><br>
            <strong>Prioritate:</strong> P03. Protejarea dreptului la demnitate socială
            <strong>Obiectiv specific:</strong> ESO4.1, Acțiunea 3.2 Economie socială în mediul rural (FSE+)
            <strong>Titlu proiect:</strong> Antreprenoriat social rural sustenabil in Regiunea Centru
            <strong>Cod mySMIS2021:</strong> 302211
            <strong>Solicitant:</strong> Asociația Institutul Educațional pentru Politici Sociale Margareta 
            <strong>Beneficiar Grant: Casuta Jocului S.R.L.</strong> 
        </p>
        <p>
            Pentru informații detaliate despre celelalte programe cofinanțate de Uniunea Europeană, vă invităm să vizitați
            <a class="mfe-link"
               href="https://mfe.gov.ro/"
               target="_blank"
               rel="noopener noreferrer"
               aria-label="mfe.gov.ro, link extern">
               mfe.gov.ro <span class="external-indicator" aria-hidden="true">(extern)</span>
            </a>
        </p>
    </div>

    <div class="col meniu-rapid">
     <h3 class="cj-baloo">Meniu Rapid</h3>
      @for (link of footerLinks; track link.id) {
        <p class="menu-item">
          <a [routerLink]="link.url" class="footer-link">
            {{ link.title }}
          </a>
        </p>
      }
      <!-- Zona ANPC -->
       <span class="anpc-holder">
          @for (link of anpc; track link.id) {
            <a [href]="link.url"
              [attr.aria-label]="link.ariaLabel"
              target="_blank"
              rel="noopener noreferrer">
              <span [ngClass]="'anpc-' + (link.id === 1 ? 'sal' : 'sol')"></span>
            </a>
          }
        </span>
    </div>

    <div class="col noutati">
    <h3 class="cj-baloo">Noutăți</h3>
      @for (a of articles; track a.slug) {
        <p class="news-item">
          <a [routerLink]="['/noutati', a.slug]" class="line-clamp">
            {{ a.title }}
          </a>
        </p>
      }


    </div>

    <div class="col contact">
      <h3 class="cj-baloo">Contact</h3>

      <p><a href="tel:0752555111">0752.555.111</a></p>
      <p><a href="mailto:office@casutajocului.ro">office@casutajocului.ro</a></p>
      <br>
      <p>Str. Viitorului, nr. 14,<br/>Sâncraiu de Mureș</p>
      <br>
      <a mat-flat-button class="cj-button cta" [routerLink]="'/contact'">
        Contact
        <mat-icon>chevron_right</mat-icon>
      </a>
    </div>
  </div>

  <!-- Rândul 2: 1 coloană (mai închis, text #ddd) -->
  <div class="bottom">
    <div class="wrap">
      <span>© {{ year }} Casuta Jocului</span>
      <span class="muted">
        Toate drepturile rezervate.
      </span>
    </div>
  </div>
</footer>
